module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Glenn A. Knoblock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Historian Glenn A. Knoblock is the author of several books with Arcadia and The History Press, including "), _c('I', [_vm._v("New Hampshire Covered Bridges, Brewing in New Hampshire")]), _vm._v(" (with James Gunter), "), _c('I', [_vm._v("New England Shipbuilding")]), _vm._v(" and "), _c('I', [_vm._v("Hidden History of Lake Winnipesaukee")]), _vm._v(". He resides in Wolfeboro Falls, New Hampshire.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TdTpLj/tc-custom/9781439675762.jpg?1702529636658",
      "alt": "This image is the cover for the book New Hampshire's Kancamagus Highway, History & Guide"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Hampshire's Kancamagus Highway, History & Guide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Considered to be one of the most scenic roads in America, the Kancamagus Highway draws thousands of tourists to New Hampshire annually. ")]), _c('br'), _c('p', [_vm._v("The highway, which runs between Conway and Lincoln and through the towns of Albany and Waterville Valley, was fully opened in 1967, but the development of the highway itself took over 120 years to become a reality.  The Kancamagus is the gateway to the southern White Mountains and such celebrated natural sites as Sabbaday Falls, Lower Falls, and Rocky Gorge, to name just a few. ")]), _c('br'), _c('p', [_vm._v("Join historian and author Glenn Knoblock as he details the development of this Granite State treasure, and offers a comprehensive guide to all there is to see and do along the \"Kanc\".")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0